<app-app-shield-event-logs-search />
